import { fallbackLanguage } from '@/config/language';
import { createInertiaApp } from '@inertiajs/vue3';
import i18next from 'i18next';
import I18NextVue from 'i18next-vue';
import { App } from 'vue';

import da from '@/locales/da/translation.json';
import en from '@/locales/en/translation.json';

type InertiaAppProps = Parameters<Parameters<typeof createInertiaApp>[0]['setup']>[0]['props'];

export function initializeI18n(app: App, props: InertiaAppProps) {
    const user = props.initialPage.props.auth.user;
    i18next.init({
        lng: user?.language,
        fallbackLng: fallbackLanguage,
        debug: import.meta.env.DEV, // TODO: Remove this in production
        resources: {
            en: {
                translation: en,
            },
            da: {
                translation: da,
            },
        },
        // Ensure interpolation works properly
        interpolation: {
            escapeValue: false,
        },
    });

    app.use(I18NextVue, { i18next });
}
